import {
  ACCOUNT_DETAILS_PATH,
  SEARCH_PATH,
  UREF_PATH,
  CONTRACT_PATH,
  CONTRACT_PACKAGE_PATH,
  RouterPathsMap,
  DICTIONARY_PATH,
  TRANSACTION_DETAILS_PATH,
} from '../router/paths';
import { NamedKeyPrefix } from '@make-software/cspr-design';
import { hashPrefixRegEx } from '../hooks/search-utils';

export enum NamedKeyPrefixExtended {
  ENTITY_CONTRACT = 'entity-contract-',
}

export const pathByPrefix = {
  [NamedKeyPrefix.ACCOUNT_HASH]: ACCOUNT_DETAILS_PATH,
  [NamedKeyPrefix.BID_PREFIX]: null,
  [NamedKeyPrefix.BALANCE_PREFIX]: null,
  [NamedKeyPrefix.DEPLOY]: TRANSACTION_DETAILS_PATH,
  [NamedKeyPrefix.DICTIONARY_PREFIX]: DICTIONARY_PATH,
  [NamedKeyPrefix.ERA_INFO_PREFIX]: null,
  [NamedKeyPrefix.HASH]: SEARCH_PATH,
  [NamedKeyPrefix.CONTRACT]: CONTRACT_PATH,
  [NamedKeyPrefixExtended.ENTITY_CONTRACT]: CONTRACT_PATH,
  [NamedKeyPrefix.CONTRACT_PACKAGE]: CONTRACT_PACKAGE_PATH,
  [NamedKeyPrefix.WITHDRAW_PREFIX]: null,
  [NamedKeyPrefix.UREF]: UREF_PATH,
};

export interface SplitDataType {
  prefix: string;
  hash: string;
  path: keyof RouterPathsMap | null;
}

// TODO: PARTIALLY MOVE TO LIB
export const deriveSplitDataFromNamedKeyValue = (
  namedKeyValue: string
): SplitDataType => {
  const [hash, lastDigits] = namedKeyValue
    .replace(hashPrefixRegEx, '')
    .split('-');

  const formattedPrefix = namedKeyValue.match(hashPrefixRegEx)
    ? namedKeyValue.match(hashPrefixRegEx)![0]
    : '';

  const formattedHash = lastDigits ? `${hash}-${lastDigits}` : `${hash}`;

  const path = pathByPrefix[formattedPrefix];

  return {
    prefix: formattedPrefix,
    hash: formattedHash,
    path,
  };
};
